import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "onScroll", "onMouseEnter", "onMouseLeave", "innerRef", "children", "suppressScrollX", "suppressScrollY", "autoHide", "theme", "trackGap", "trackStyle", "thumbStyle", "minThumbSize", "Wrapper"];
import React, { useImperativeHandle, useRef } from "react";
import useScrollbar from "./useScrollbar";
import "./ScrollWrapper.less";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ScrollWrapper(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    onScroll = _ref.onScroll,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    innerRef = _ref.innerRef,
    children = _ref.children,
    suppressScrollX = _ref.suppressScrollX,
    suppressScrollY = _ref.suppressScrollY,
    _ref$autoHide = _ref.autoHide,
    autoHide = _ref$autoHide === void 0 ? true : _ref$autoHide,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "light" : _ref$theme,
    trackGap = _ref.trackGap,
    trackStyle = _ref.trackStyle,
    thumbStyle = _ref.thumbStyle,
    minThumbSize = _ref.minThumbSize,
    Wrapper = _ref.Wrapper,
    props = _objectWithoutProperties(_ref, _excluded);
  var scrollBoxRef = useRef(null);
  useImperativeHandle(innerRef, function () {
    return scrollBoxRef.current;
  });
  var _useScrollbar = useScrollbar(scrollBoxRef, {
      trackGap: trackGap,
      trackStyle: trackStyle,
      thumbStyle: thumbStyle,
      minThumbSize: minThumbSize,
      autoHide: autoHide
    }),
    _useScrollbar2 = _slicedToArray(_useScrollbar, 5),
    horizontalBar = _useScrollbar2[0],
    verticalBar = _useScrollbar2[1],
    updateLayerNow = _useScrollbar2[2],
    updateLayerThrottle = _useScrollbar2[3],
    hideScrollbar = _useScrollbar2[4];
  function handleScroll(evt) {
    if (onScroll) {
      onScroll(evt);
    }
    updateLayerThrottle();
  }
  function handleMouseEnter(evt) {
    if (onMouseEnter) {
      onMouseEnter(evt);
    }
    updateLayerNow();
  }
  function handleMouseLeave(evt) {
    if (onMouseLeave) {
      onMouseLeave(evt);
    }
    hideScrollbar();
  }
  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({
    className: "ms-container".concat(className && " ".concat(className)),
    ref: scrollBoxRef,
    onScroll: handleScroll,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "ms-track-box ms-theme-".concat(theme),
      children: [!suppressScrollX && horizontalBar, !suppressScrollY && verticalBar]
    }), children]
  }));
}